// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ComputeMaxWaterdepthInput } from "./ComputeMaxWaterdepthInput";
import {
  ComputeMaxWaterdepthInputFromJSON,
  ComputeMaxWaterdepthInputFromJSONTyped,
  ComputeMaxWaterdepthInputToJSON,
  ComputeMaxWaterdepthInputToJSONTyped,
} from "./ComputeMaxWaterdepthInput";
import type { ComputeMaxWaterdepthOutput } from "./ComputeMaxWaterdepthOutput";
import {
  ComputeMaxWaterdepthOutputFromJSON,
  ComputeMaxWaterdepthOutputFromJSONTyped,
  ComputeMaxWaterdepthOutputToJSON,
  ComputeMaxWaterdepthOutputToJSONTyped,
} from "./ComputeMaxWaterdepthOutput";

/**
 *
 * @export
 * @interface ComputeMaxWaterdepthSchema
 */
export interface ComputeMaxWaterdepthSchema {
  /**
   *
   */
  tag: ComputeMaxWaterdepthSchemaTagEnum;
  /**
   *
   */
  inputs: ComputeMaxWaterdepthInput;
  /**
   *
   */
  outputs: ComputeMaxWaterdepthOutput;
}

/**
 * @export
 */
export const ComputeMaxWaterdepthSchemaTagEnum = {
  ComputeMaxWaterdepth: "compute_max_waterdepth",
} as const;
export type ComputeMaxWaterdepthSchemaTagEnum =
  (typeof ComputeMaxWaterdepthSchemaTagEnum)[keyof typeof ComputeMaxWaterdepthSchemaTagEnum];

/**
 * Check if a given object implements the ComputeMaxWaterdepthSchema interface.
 */
export function instanceOfComputeMaxWaterdepthSchema(
  value: object
): value is ComputeMaxWaterdepthSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "compute_max_waterdepth") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function ComputeMaxWaterdepthSchemaFromJSON(json: any): ComputeMaxWaterdepthSchema {
  return ComputeMaxWaterdepthSchemaFromJSONTyped(json, false);
}

export function ComputeMaxWaterdepthSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ComputeMaxWaterdepthSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: ComputeMaxWaterdepthInputFromJSON(json["inputs"]),
    outputs: ComputeMaxWaterdepthOutputFromJSON(json["outputs"]),
  };
}

export function ComputeMaxWaterdepthSchemaToJSON(json: any): ComputeMaxWaterdepthSchema {
  return ComputeMaxWaterdepthSchemaToJSONTyped(json, false);
}

export function ComputeMaxWaterdepthSchemaToJSONTyped(
  value?: ComputeMaxWaterdepthSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: ComputeMaxWaterdepthInputToJSON(value["inputs"]),
    outputs: ComputeMaxWaterdepthOutputToJSON(value["outputs"]),
  };
}
